import React, {useMemo} from 'react';
import cn from 'classnames';

import {VisibilityContextProvider} from 'brand/app/contexts/viewportProductContext';
import useViewItemListEvent from 'brandHooks/useViewItemListEvent';

import {IProductRecommendation} from './IProductRecommendation';
import {RecommendationsCarousel} from './Subcomponents';

import styles from './ProductRecommendation.module.scss';

const ProductRecommendation = ({products, bigTile = false, classNames, source, title}: IProductRecommendation) => {
	const {handleProductVisibility} = useViewItemListEvent(products, source);

	const visibilityContextValue = useMemo(
		() => ({
			handleVisibilityChange: handleProductVisibility,
		}),
		[handleProductVisibility],
	);

	if (!products?.length) {
		return null;
	}

	return (
		<VisibilityContextProvider value={visibilityContextValue}>
			<section
				className={cn(
					'product-recommendation',
					styles['product-recommendation'],
					{[styles['product-recommendation--big-tile']]: bigTile},
					classNames,
				)}
			>
				{title && <span className="product-recommendation--title">{title}</span>}
				<RecommendationsCarousel
					key={`product-recommendation-carousel${bigTile ? '--big-tile' : ''}`}
					products={products}
					bigTile={bigTile}
					source={source}
				/>
			</section>
		</VisibilityContextProvider>
	);
};

export default ProductRecommendation;
